module.exports = __webpack_public_path__ + "assets/videos/floorplan/floorplan-2020/0133.jpg?v=537c13b7";